import ApiService from "../apiService";
import { get, post, destroy } from "../apiService";
const _ = require("lodash");
const model = "users";

export default class UserService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        "filter[internal_users]": true
      }
    });
  }
  findAllClinicians() {
    return get(`/clinicians`, {
      params: {
        include: "user"
      }
    });
  }
  lookup(email) {
    return get(`/${model}`, {
      params: {
        "filter[email]": email
      }
    });
  }

  find(id) {
    return get(`/${model}/${id}`, {
      params: {}
    });
  }

  dashboard() {
    return get(`/dashboard`, {
      params: {}
    });
  }

  acceptTerms(id) {
    return post(`/users/${id}/accept_terms`, {
      data: { type: "users", id: id }
    });
  }
  sendReminder(id) {
    return post(`/users/${id}/send_reminder`, {
      data: { type: "users", id: id }
    });
  }
  save(itemToSave) {
    var item = _.cloneDeep(itemToSave);
    delete item.attributes["patientConditionId"];
    delete item.attributes["patientId"];

    delete item.attributes["acceptedTerms"];
    delete item.attributes["userRoles"];
    delete item.attributes["confirmEmail"];
    delete item.attributes["resetPasswordToken"];
    delete item.attributes["resetPasswordSentAt"];
    delete item.attributes["createdAt"];
    delete item.attributes["updatedAt"];
    delete item["roles"];
    return this.baseSave(model, item);
  }
  deletePermission(userId, patientConditionId) {
    return destroy(`/users/${userId}/permission/${patientConditionId}`, {});
  }
  addRole(id, role, patientConditionId) {
    return post(`/users/${id}/permission`, {
      data: {
        type: "users",
        id: id,
        attributes: { role: role, patientConditionId: patientConditionId }
      }
    });
  }

  archive(item) {
    return this.baseArchive(model, item);
  }
}



// WEBPACK FOOTER //
// ./src/services/userService/index.js